// Version : 1.0.0
// Author : AGALYA
import DrivingLicenceActionType from './driving-licence-details.types';

/** ***************** UPDATE DRIVING LICENCE START *********************** */
export const updateDrivingLicenceStart = (DrivingLicenceCredentials: any) => ({
	type: DrivingLicenceActionType.UPDATE_DRIVING_LICENCE_START,
	payload: DrivingLicenceCredentials,
});

export const updateDrivingLicenceSuccess = (DrivingLicenceSuccess: any) => ({
	type: DrivingLicenceActionType.UPDATE_DRIVING_LICENCE_SUCCESS,
	payload: DrivingLicenceSuccess,
});

export const updateDrivingLicenceFailure = (DrivingLicenceFailure: any) => ({
	type: DrivingLicenceActionType.UPDATE_DRIVING_LICENCE_FAILURE,
	payload: DrivingLicenceFailure,
});

export const updateDrivingLicenceResponseResetStart = () => ({
	type: DrivingLicenceActionType.UPDATE_DRIVING_LICENCE_RESPONSE_REST_START,
});

export const updateDrivingLicenceResponseChanged = () => ({
	type: DrivingLicenceActionType.UPDATE_DRIVING_LICENCE_RESPONSE_CHANGED,
});
/** ***************** UPDATE DRIVING LICENCE END *********************** */
